//
//
//
//
//
//
//

import PersonalSection from './personal_section.vue'
export default {
    props: {
        is_login: Boolean
    },
    components: {
        PersonalSection
    },
    computed: {
        tabs () {
            const PHONE_CALL = {
                icon: 'phone_call',
                name: '通话记录',
                url: '/pages/personal_package/phone_call/main'
            }
            const tabs = [
                {
                    icon: 'find_building',
                    name: '找房',
                    url: '/find_building'
                },
                {
                    icon: 'first_payment',
                    name: '测首付',
                    url: '/first_payment'
                },
                {
                    icon: 'taxes',
                    name: '税费计算',
                    url: '/packageA/taxes_calculate/main'
                },
                {
                    icon: 'provident_fund',
                    name: '公积金贷款',
                    url: '/packageB/provident_fund/main'
                },
                {
                    icon: 'prepayment',
                    name: '提前还款',
                    url: '/packageA/prepayment_calc/main'
                },
                {
                    icon: 'qualification',
                    name: '查户口迁移',
                    url: '/pages/personal_package/verify_qualification/main'
                },
                {
                    icon: 'dora',
                    name: '查权属',
                    url: '/pages/personal_package/dora/main'
                },
                {
                    icon: 'inherit',
                    name: '查继承',
                    url: '/pages/personal_package/inherit/main'
                }
            ]
            if (this.is_login) {
                tabs.unshift(PHONE_CALL)
            }
            return tabs
        }
    }
}
